import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

// Shared fetch for the Terms & Conditions template picker used on
// Raise Transfer Order, Quotations and Purchase Orders. All three
// pages call this one hook instead of each hitting `GET /terms`
// themselves, so the "fetch active templates" logic lives in a single
// place. Settings → Company Profile manages the full (unfiltered)
// template list separately, since it needs inactive templates too.
export function useActiveTermsTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/terms", { params: { active: true } });
      setTemplates(data || []);
    } catch {
      setTemplates([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { templates, loading, reload };
}
